import { GoogleMaterialIcon } from '../../ui/GoogleMaterialIcon';
import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { Box } from '@mui/material';
import _ from "lodash";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogContent, Typography } from "@mui/material";
import { Tooltip } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import MultiSelect from "../../common/MultiSelect";
import IconButton from "@mui/material/IconButton";
import MuiButton from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import dayjs, { Dayjs } from "dayjs";
import ClientFilingMasterContext from "../../../context/client-filing-master/ClientFilingMasterContext";
import AuthContext from "../../../context/auth/AuthContext";
import CalendarDetailsReferenceDocuments from "./CalendarDetailsReferenceDocuments";
import CalendarDetailsAttachment from "./CalendarDetailsAttachment";
import CalendarDetailsComments from "./CalendarDetailsComments";
import usePermission from "../../../usePermission";
import states from "../../../data/StateLookup.json";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import CustomerContext from "../../../context/customer/CustomerContext";
import { useCommonDetailsContext } from "../../../context/Common/common";
import { tokens } from '../../../theme/tokens';
import {
  fetchCalendarEventDetails,
  fetchStaffAssignedList,
  syncCalendarEventPeriodDueDate,
  updateCalendarEventDetails,
} from "./helper";
import { Stack } from '@mui/material';
import { TrackNowSelect } from '../../ui';
import { TrackNowButton } from '../../ui';
import { capitalizeLeadingText } from '../../../utils/textFormat';

const CalendarDetailsDialog = (props) => {
  const { publishedBranding, clientScopedBranding, validateParentData } = useCommonDetailsContext();
  const activeBranding = validateParentData?.isSingleParent ? publishedBranding : (clientScopedBranding || publishedBranding);
  const primaryColor =
    activeBranding?.primaryColor || tokens.colors.connectedPurple;
  let { clientId } = useParams();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [calendarDetails, setCalendarDetails] = useState({});
  const [affectedCompaniesDetails, setAffectedCompaniesDetails] = useState([]);
  const [staffListOptions, setStaffListOptions] = useState([]);

  const [selectedStaffAssigned, setSelectedStaffAssigned] = useState([]);
  const [selectedFilingDueDate, setSelectedFilingDueDate] = useState(null);
  const [alertMessage, setAlertMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState("");
  const authContext = useContext(AuthContext);
  const { authUser, userRoles } = authContext;
  const clientFilingMasterContext = useContext(ClientFilingMasterContext);
  const { selectedTrackerCalendarEvent, selectedTrackerCalendarEventDisplay } =
    clientFilingMasterContext;
  const hasChangeStatusPermission = usePermission(
    "ClientFilingList",
    "changeStatus",
  );
  const customerContext = useContext(CustomerContext);
  const { selectedCustomer } = customerContext;
  const [statusOptValue, setStatusOptValue] = useState("")
  const statusDropdown = [
    { name: 'Pending', code: 'Pending' },
    { name: 'In progress', code: 'In progress' },
    { name: 'Approved', code: 'Approved' },
    { name: 'Completed', code: 'Completed' },
  ];
  const handleClose = () => {
    props.handleClose();
    setStatusOptValue("")
  };

  const formatDayJs = (value) => {
    const formtDueDate = value !== null ? dayjs(value) : null;
    return formtDueDate;
  };

  const formatDate = (value) => {
    return value && value !== null
      ? value?.toLocaleDateString("en-US", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      : null;
  };

  const getStateName = (stateCode) => {
    const state = states.find((s) => s.code === stateCode);
    return state ? state.state : stateCode;
  };

  const hasChangeDueDatePermission = usePermission(
    "ClientFilingList",
    "changeStatusAndDueDate",
    clientId
  );

  const isDueDateDisabled = () => {
    // console.log("isDueDateDisabled", calendarDetails);
    return (
      !hasChangeDueDatePermission ||
      (calendarDetails.recordType === "TrackNow" &&
        calendarDetails.isMasterFiling)
    );
  };

  const handleClear = () => {
    console.log("handleClear props", calendarDetails);
    let staffAssignedVal = calendarDetails.staffAssigned.map(
      (ele) => ele.userId
    );
    setSelectedStaffAssigned(staffAssignedVal);
    setSelectedFilingDueDate(null);
    setStatusOptValue(calendarDetails?.status || "")
    setAlertMessage("")
    setShowError(false)
    setShowSuccess(false)
  };

  const handleStatausChange = (events) => {
    setStatusOptValue(events.target.value);
  };

  const normalizeDateValue = (dateValue) => {
    if (!dateValue) return null;
    return new Date(dateValue).toISOString().slice(0, 10);
  };

  const toUtcDateOnly = (dateValue) => {
    if (!dateValue) return null;

    const parsedDate = dateValue instanceof Date ? dateValue : new Date(dateValue);

    if (Number.isNaN(parsedDate.getTime())) {
      return null;
    }

    return new Date(
      Date.UTC(
        parsedDate.getFullYear(),
        parsedDate.getMonth(),
        parsedDate.getDate()
      )
    );
  };

  const getInitialStaffAssigned = () =>
    Array.isArray(calendarDetails?.staffAssigned)
      ? calendarDetails.staffAssigned.map((staff) => staff.userId).sort()
      : [];

  const getCurrentStaffAssigned = () =>
    Array.isArray(selectedStaffAssigned)
      ? [...selectedStaffAssigned].sort()
      : [];

  const hasStaffAssignedChanged = () => {
    const initialStaffAssigned = getInitialStaffAssigned();
    const currentStaffAssigned = getCurrentStaffAssigned();

    if (initialStaffAssigned.length !== currentStaffAssigned.length) {
      return true;
    }

    return initialStaffAssigned.some(
      (staffId, index) => staffId !== currentStaffAssigned[index]
    );
  };

  const getSubmittedFilingDueDate = () =>
    selectedFilingDueDate || calendarDetails?.filingDueDate || null;

  const hasFilingDueDateChanged = () =>
    normalizeDateValue(calendarDetails?.filingDueDate) !==
    normalizeDateValue(getSubmittedFilingDueDate());

  const getSubmittedStatus = () => statusOptValue || calendarDetails?.status || "";

  const hasStatusChanged = () =>
    Boolean(calendarDetails?.status) &&
    getSubmittedStatus() !== calendarDetails.status;

  const hasPendingChanges =
    hasStaffAssignedChanged() ||
    hasFilingDueDateChanged() ||
    hasStatusChanged();

  const DetailItem = ({ property, value }) => {
    const displayValue =
      property === "Rule Info"
        ? capitalizeLeadingText(value)
        : value;
    // console.log("property", property, "value", value, "backgroundColor", backgroundColor);
    return (
      <div style={{ display: "flex" }}>
        <h5 style={{ margin: "0" }}>{property}: </h5>
        <h5
          style={{
            fontWeight: "normal",
            margin: "0 0 0 0.5rem",
            backgroundColor: property === "Status" ? backgroundColor : "none",
            padding: property === "Status" && backgroundColor ? "3px" : 0,
            color: property === "Status" && backgroundColor ? "white" : "black",
            borderRadius:
              property === "Status" && backgroundColor ? "5px" : "0px",
          }}
        >
          {displayValue}
        </h5>
      </div>
    );
  };

  const updateCalendarDetails = async () => {
    setIsLoading(true);
    console.log("updateCalendarDetails calendarDetails", calendarDetails);

    try {
      const { dueDateVal, ...calendarDetailsPayload } = calendarDetails;
      const submittedDueDate = toUtcDateOnly(getSubmittedFilingDueDate());
      console.log("updateCalendarDetails", "calendarDetailsPayload", calendarDetailsPayload, "dueDateVal", dueDateVal);
      let payload = {
        ...calendarDetailsPayload,
        dueDate: submittedDueDate,
        filingDueDate: submittedDueDate,
        updateDate: new Date(),
        updateUser: authUser.userId + "",
        grantTermComplete: calendarDetails.grantTermComplete === "Yes",
        status: getSubmittedStatus()
      };
      console.log("updateCalendarDetails", payload, calendarDetails);

      // Remove the staffAssigned from the payload
      const { staffAssigned, ...rest } = payload;

      // Extract and update staff assignment details
      const exsistingStaffsDetails = staffAssigned
        .filter((staff) => selectedStaffAssigned.includes(staff.userId))
        .map((staff) => ({
          staffAssignedId: staff.staffAssignedId,
          userId: staff.userId,
          isDeleted: false,
        }));

      const removedStaffsDetails = staffAssigned
        .filter((staff) => !selectedStaffAssigned.includes(staff.userId))
        .map((staff) => ({
          staffAssignedId: staff.staffAssignedId,
          userId: staff.userId,
          isDeleted: true,
        }));

      const newLyAddedStaffs = selectedStaffAssigned
        .filter(
          (newEle) => !staffAssigned.some((oldEle) => newEle === oldEle.userId)
        )
        .map((ele) => ({
          staffAssignedId: 0,
          userId: ele,
          isDeleted: false,
        }));

      const staffAssignedPayload = [
        ...exsistingStaffsDetails,
        ...removedStaffsDetails,
        ...newLyAddedStaffs,
      ];

      const isFilingDueDateChanged = hasFilingDueDateChanged();

      payload = {
        ...rest,
        staffAssigned: staffAssignedPayload.map((ele) => ({
          staffAssignedId: ele.staffAssignedId,
          fileTrackingID: calendarDetails.fileTrackingId,
          userId: ele.userId,
          isDeleted: ele.isDeleted,
          createDate: new Date(),
          createUser: authUser.userId + "",
          updateDate: new Date(),
          updateUser: authUser.userId + "",
        })),
        dueDate: submittedDueDate,
        filingDueDate: submittedDueDate,
      };

      const res = await updateCalendarEventDetails([payload]);
      if (isFilingDueDateChanged) {
        await syncCalendarEventPeriodDueDate(calendarDetails.fileTrackingId);
      }
      console.log("calendarDetails payload", payload, res, statusOptValue);

      if (res) {
        fetchCalendarDetails();
        props.refreshCalender();
        setAlertMessage("Filing has been successfully updated");
        setShowError(false);
        setStatusOptValue("")
        setShowSuccess(true);
      }
    } catch (error) {
      setAlertMessage("Error while updating filing");
      setShowError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCalendarDetails = async () => {
    const { fileTrackingId, customerId } =
      selectedTrackerCalendarEventDisplay._def.extendedProps;

    try {
      const res = await fetchCalendarEventDetails(fileTrackingId, customerId, props.currentCalendarYear);

      let details = res[0];
      details.filingStateVal = getStateName(details.filingStateInfo);
      details.dueDateVal =
        details.filingDueDate !== null
          ? formatDate(new Date(details.filingDueDate))
          : null;
      details.awardTypeName =
        details.awardType && details.awardType.length > 0
          ? details.awardType[0].awardTypeName
          : "";
      details.awardingAgencyName =
        details.awardingAgency && details.awardingAgency.length > 0
          ? details.awardingAgency[0].awardingAgencyName
          : "";
      const filingPeriods1 = details.startdate
        ? new Date(details.startdate)
        : "";

      let staffAssignedVal = details.staffAssigned.map((ele) => ele.userId);
      setSelectedStaffAssigned(staffAssignedVal);
      setStatusOptValue(details.status || "");

      const filingPeriods2 = details.enddate ? new Date(details.enddate) : "";
      details.filingPeriodVal = `${formatDate(filingPeriods1)} - ${formatDate(
        filingPeriods2
      )}`;
      const programName =
        details.programInfo && details.programInfo.length > 0
          ? details.programInfo[0].programName
          : "";

      if (details.filingJuristiction?.includes("Federal")) {
        const _categories = _.map(
          details.businessCategory,
          "businessCategoryName"
        ).join(", ");
        if (details.recordType === "TrackNow") {
          details.federalCategories = _categories;
        } else {
          details.federalCategories = programName;
        }
      } else if (details.filingJuristiction?.includes("Both")) {
        const categoriesState = details.businessCategory.filter(
          (ele) => ele.state === details.filingStateInfo
        );
        const _categories = categoriesState
          .map((ele) => ele.businessCategoryName)
          .join(", ");

        if (details.recordType === "TrackNow") {
          details.federalCategories = _categories;
          details.stateCategories = _categories;
        } else {
          details.federalCategories = programName;
          details.stateCategories = programName;
        }
      } else {
        const categoriesState = details.businessCategory.filter(
          (ele) => ele.state === details.filingStateInfo
        );
        const _categories = categoriesState
          .map((ele) => ele.businessCategoryName)
          .join(", ");
        if (details.recordType === "TrackNow") {
          details.stateCategories = _categories;
        } else {
          details.stateCategories = programName;
        }
      }

      setCalendarDetails(res[0]);
      console.log("staff check details ", details);

      getStaffList(details);
      viewAffectedCompanies(details);
    } catch (err) {
      console.log("fetchCalendarDetails err", err);
    }
  };

  const getStaffList = (details) => {

    // Filter users based on role and customerId
    const staffList = userRoles
      .filter(
        (ele) =>
          // ele.roleName === "Admin" ||
          // ele.roleName === "Admin-PostAward" ||
          parseInt(clientId) === ele.customerId
      ) // Remove duplicates based on userName
      .filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.userName === value.userName)
      )
      .sort((a, b) => a.userName.localeCompare(b.userName));
    // console.log("getStaffList staffList", staffList);
    let staffAssignedOptions = [];
    //Filtered based on the recordType
    if (details.recordType === "TrackNow") {
      staffAssignedOptions = staffList.filter(
        (ele) =>
          // ele.roleName === "Admin-PostAward" ||
          !ele.roleName.includes("PostAward")
      ).map((ele) => ({
        name: ele.userName.charAt(0).toUpperCase() + ele.userName.slice(1),
        code: ele.userId,
      }));
    } else {
      staffAssignedOptions = staffList.map((ele) => ({
        name: ele.userName.charAt(0).toUpperCase() + ele.userName.slice(1),
        code: ele.userId,
      }));
    }

    // console.log("getStaffList staffAssignedOptions", staffAssignedOptions);
    // console.log("staff check staffAssignedOptions ", staffAssignedOptions);

    setStaffListOptions(staffAssignedOptions);
  };

  const handleFilingDueDateChange = (date) => {
    // console.log("handleFilingDueDateChange", "date", date, "d", date.$d);
    setSelectedFilingDueDate(date?.$d ?? null);
  };

  const handleChangeStaffAssigned = (values) => {
    if (values) {
      setSelectedStaffAssigned(values);
    }
  };

  const viewAffectedCompanies = async (details) => {
    const { filingId, customerId } =
      selectedTrackerCalendarEventDisplay._def.extendedProps;
    const res = await fetchStaffAssignedList(
      details.previousStartDate,
      filingId,
      clientId
    );
    console.log("viewAffectedCompanies res", res);
    if (res) {
      let companyNames = res.map((ele) => ele.customerName);
      console.log("viewAffectedCompanies companyNames", companyNames);
      setAffectedCompaniesDetails(companyNames);
    }
  };

  useEffect(() => { }, [staffListOptions]);

  useEffect(() => {
    if (calendarDetails) {
      // console.log("calendarDetails", calendarDetails);
      const checkPastDueDate = () => {
        const filingDueDate = new Date(calendarDetails.filingDueDate); // Parse the filingDueDate
        const currentDate = new Date(); // Get the current date

        // Compare filingDueDate with currentDate
        filingDueDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);
        return filingDueDate < currentDate;
      };

      // Simplified backgroundColor logic
      const status = calendarDetails.status;
      const isPastDueDate = checkPastDueDate();
      console.log("status", status);
      console.log("isPastDueDate", isPastDueDate);

      if (status === "Completed") {
        setBackgroundColor("#28a745"); // Green for all dates with status Completed
      } else if (isPastDueDate) {
        setBackgroundColor("#dc3545"); // Red for past due dates, excluding Completed status
      } else {
        setBackgroundColor("");
      }
    }
  }, [calendarDetails]);

  useEffect(() => {
    if (props.open && selectedTrackerCalendarEventDisplay) {
      setCalendarDetails({});
      setAlertMessage("");
      setShowError(false);
      setShowSuccess(false);
      setAffectedCompaniesDetails([]);
      fetchCalendarDetails();
    }
    setOpen(props.open);
  }, [props.open]);

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      onClose={handleClose}
      open={open}
      style={{ zIndex: 1000 }}
      PaperProps={{
        sx: {
          backgroundColor: tokens.colors.offWhite,
          border: `1px solid ${primaryColor}22`,
          borderRadius: "16px",
          boxShadow: `0 10px 30px ${primaryColor}2e`,
          fontFamily: "Area Normal, Inter, sans-serif",
        },
      }}
    >
      <Stack display="flex" flexDirection="row" justifyContent="space-between">
        <DialogTitle

          sx={{
            padding: "10px 24px",
            fontWeight: 700,
            fontSize: "20px",
            color: primaryColor,
            fontFamily: "Area Normal, Inter, sans-serif",
          }}
        >
          {calendarDetails.filingName}
        </DialogTitle>
        <DialogTitle
          sx={{
            padding: "10px 24px",
            fontWeight: 700,
            fontSize: "20px",
            color: primaryColor,
          }}
        >
          <GoogleMaterialIcon onClick={handleClose} name="close" color={primaryColor} />
        </DialogTitle>
      </Stack>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid sm={6} lg={3}>
            <DetailItem
              property="Filing Due Date"
              value={calendarDetails.dueDateVal}
            />
          </Grid>

          {calendarDetails.recordType === "PostAward" && (
            <Grid sm={6} lg={3}>
              <DetailItem
                property="Filing Period"
                value={calendarDetails.filingPeriodVal}
              />
            </Grid>
          )}

          <Grid sm={6} lg={3}>
            <DetailItem property="Status" value={calendarDetails.status} />
          </Grid>

          {calendarDetails.recordType === "PostAward" && (
            <Grid sm={6} lg={3}>
              <DetailItem
                property="Grant Term Complete"
                value={
                  calendarDetails.grantTermComplete === "Yes" ||
                    calendarDetails.grantTermComplete === true
                    ? "Yes"
                    : "No"
                }
              />
            </Grid>
          )}

          <Grid sm={6} lg={3}>
            <DetailItem
              property="Filing Frequency"
              value={calendarDetails.filingFrequency}
            />
          </Grid>

          <Grid sm={6} lg={3}>
            <DetailItem
              property="State"
              value={calendarDetails.filingStateVal}
            />
          </Grid>

          {calendarDetails.recordType === "TrackNow" && (
            <Grid sm={6} lg={3}>
              <DetailItem
                property="Rule Info"
                value={calendarDetails.ruleInfo}
              />
            </Grid>
          )}

          <Grid sm={6} lg={3}>
            <DetailItem
              property="Jurisdiction"
              value={calendarDetails.filingJuristiction}
            />
          </Grid>

          {calendarDetails.recordType === "TrackNow" && (
            <Grid sm={6} lg={3}>
              <DetailItem
                property="Required"
                value={calendarDetails.filingRequired ? "True" : "False"}
              />
            </Grid>
          )}

          {calendarDetails.recordType === "PostAward" && (
            <Grid sm={6} lg={6}>
              <DetailItem
                property="Award Type"
                value={calendarDetails.awardTypeName}
              />
            </Grid>
          )}

          {calendarDetails.recordType === "PostAward" && (
            <Grid sm={6} lg={6}>
              <DetailItem
                property="Award Agency"
                value={calendarDetails.awardingAgencyName}
              />
            </Grid>
          )}

          {calendarDetails.recordType === "TrackNow" && (
            <Grid sm={6} lg={6}>
              <DetailItem
                property="Who Must File Federal"
                value={calendarDetails.federalCategories}
              />
            </Grid>
          )}

          {calendarDetails.recordType === "TrackNow" && (
            <Grid sm={6} lg={6}>
              <DetailItem
                property="Who Must File in State"
                value={calendarDetails.stateCategories}
              />
            </Grid>
          )}

          <Grid sm={12} lg={12}>
            <DetailItem
              property="Affected Companies"
              value={affectedCompaniesDetails.join(" , ")}
            />
          </Grid>

          <Grid sm={12} lg={12}>
            <DetailItem
              property="Where to File"
              value={calendarDetails.whereToFile}
            />
          </Grid>

          <Grid sm={12} lg={12}>
            <DetailItem property="Notes" value={calendarDetails.notes} />
          </Grid>

          <Grid sm={12} lg={12}>
            <CalendarDetailsAttachment />
          </Grid>

          <Grid sm={12} lg={12}>
            <CalendarDetailsReferenceDocuments />
          </Grid>

          <Grid sm={12} lg={12}>
            <CalendarDetailsComments />
          </Grid>

          <Grid item xs={12} sm={3} lg={3}>
            <h5 style={{ margin: "0.5rem 0" }}>Staff Assigned:</h5>
            <Tooltip
              placement="top"
              title={
                selectedStaffAssigned.length > 0 ? (
                  <div>
                    {selectedStaffAssigned.map((staff, index) => {
                      const filtName = staffListOptions
                        .filter(item => item.code === staff)
                        .map(staff => staff.name)
                        .join(", ");

                      return (
                        <Typography key={index} variant="body2">
                          {filtName}
                        </Typography>
                      );
                    })}
                  </div>
                ) : (
                  "No Staff Assigned"
                )
              }
              arrow // Adds an arrow to the Tooltip
            >

              {/* Tooltip triggers on hover over this wrapper */}
              <MultiSelect
                inputs={staffListOptions.map((item) => ({
                  name: `${item.name}`,
                  value: item.code ? item.code : "",
                }))}
                values={selectedStaffAssigned}
                initValues={selectedStaffAssigned}
                updateSelection={handleChangeStaffAssigned}
                placeholder="Select Staff"
                maxSelectedLabels={6}
              />

            </Tooltip>
          </Grid>

          <Grid item xs={12} sm={3} lg={3} >
            <h5 style={{ margin: "0.5rem 0", marginBottom: "0px" }}>Due Date:</h5>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}
              >
                <DemoItem>
                  <DatePicker
                    disabled={isDueDateDisabled()}
                    onChange={handleFilingDueDateChange}
                    value={
                      selectedFilingDueDate
                        ? formatDayJs(selectedFilingDueDate)
                        : formatDayJs(calendarDetails.dueDateVal)
                    }
                  />
                </DemoItem>
              </DemoContainer>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} sm={3} lg={3}>

            <h5 style={{ margin: "0.5rem 0" }}>Status:</h5>

            <FormControl fullWidth>
              <TrackNowSelect
                value={getSubmittedStatus()}
                onChange={handleStatausChange}
                displayEmpty
                disabled={!(hasChangeStatusPermission &&
                  selectedCustomer &&
                  (selectedCustomer.isOnlyChildFile ||
                    selectedCustomer.isOnlyParentFile))}
                sx={{

                  minWidth: "220px",
                  height: "44px",
                  borderRadius: "24px",
                }}
                renderValue={(selected) => {
                  if (!selected) {
                    return <span style={{ color: "#9E9E9E" }}>Select status</span>;
                  }
                  const match = statusDropdown.find((item) => item.code === selected);
                  return match ? match.name : selected;
                }}
              >
                {statusDropdown.map((item, index) => (
                  <MenuItem key={index} value={item.code}>
                    {item.name}
                  </MenuItem>
                ))}
              </TrackNowSelect>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={3} lg={3} sx={{ alignContent: "end" }}>
            <div
              style={{ display: "flex", justifyContent: "end", }}
            >
              <TrackNowButton
                size="small"
                variant="tertiary"
                color="primary"
                disabled={isLoading}
                onClick={handleClear}
              >
                Clear
              </TrackNowButton>
              <TrackNowButton
                size="small"
                variant="primary"
                type="submit"
                disabled={isLoading || !hasPendingChanges}

                onClick={updateCalendarDetails}
              >
                Update
              </TrackNowButton>
            </div>
          </Grid>

          <Grid x={12} lg={6}>
            <div>
              {showError && <Alert severity="error">{alertMessage}</Alert>}
              {showSuccess && <Alert severity="success">{alertMessage}</Alert>}
            </div>
          </Grid>


        </Grid>
      </DialogContent >
    </Dialog >
  );
};

export default CalendarDetailsDialog;
